











































import {Component, Vue, Ref} from 'vue-property-decorator';
import PageHeader from '@/components/PageHeader/index.vue';
import SearchPanel from '@/components/SearchPanel/index.vue';
import {EmptyList} from '@/components/Empty';
import CardList from '@/components/CardList/index.vue';
import ListEditDialog from '@/views/ProjectManagement/UIConfiguration/components/formDialogs/listEditDialog.vue';
import {
  getAppList,
  appDelete, getAppDetail
} from '@/service/project-management/ui-configuration';
import XPagination from '@/components/x-components/x-pagination/index.vue';
import {Getter} from 'vuex-class';
import moment from 'moment';
import Template from '@/views/ProjectManagement/UIConfiguration/components/Drawer/LeftPanel/Page/Template.vue';
import {ContentMode} from '@/components/PageHeader/index.vue';

@Component({
  components: {
    Template,
    PageHeader,
    SearchPanel,
    EmptyList,
    CardList,
    ListEditDialog,
  },
})
export default class UIConfigurationList extends Vue {
  @Getter('pm/projectID') readonly projectID!: string;

  //@Ref
  @Ref('listEditDialog')
  readonly listEditDialogRef!: ListEditDialog;

  @Ref('pagination')
  readonly paginationRef!: XPagination;

  loading: boolean = false;

  searchVal: string = '';
  pageVisible: boolean = true;

  //data
  topHeaderValue:string = ContentMode.ad;
  ContentMode: typeof ContentMode = ContentMode;
  pageOperator: Array<any> = [
    // {
    //   label: "从界面库选择",
    //   type: "text",
    //   on: {
    //     click: () => {
    //       this.$message.success("从界面库选择");
    //     },
    //   },
    // },
    {
      label: '新建应用',
      icon: 'el-icon-plus',
      on: {
        click: () => {
          this.handleEdit();
        },
      },
    },
  ];

  //分页设置
  cardSetting: any = {
    //列表
    list: [],
    operators: [
      {
        // icon: 'el-icon-edit-outline',
        iconSvg: 'icon-edit',
        label: '编辑',
        type: 'text',
        on: {
          click: (item) => {
            this.handleEdit(item);
          },
        },
      },
      {
        // icon: 'el-icon-delete',
        iconSvg: 'icon-delete',
        label: '删除',
        type: 'text',
        on: {
          click: (item) => {
            this.appDelete(item);
          },
        },
      },
    ],
    // footers: [
    //   {
    //     label: "批量追加设备标签",
    //     on: {
    //       click: () => {
    //         this.$message.success("添加成功");
    //       },
    //     },
    //   },
    //   {
    //     label: "批量共享",
    //     on: {
    //       click: () => {
    //         this.$message.success("添加成功");
    //       },
    //     },
    //   },
    // ],
  };

  //@mounted
  mounted() {
    this.paginationRef.getList();
  }

  //新建应用
  handleAdd() {
    this.listEditDialogRef.open();
  }

  //新建应用
  handleEdit(item?: any) {
    if(item){
      getAppDetail({
        homepageId: item.sourceData.homepageId
      }).then(res => {
        const data = res.data.homepageDetail;
        this.listEditDialogRef.open({
          ...data,
          id: item.sourceData.id, //这里使用的是列表的id
          deviceTags:data.deviceTagHomepage.deviceTags.map(item => item.id),
        });
      });
    }else{
      this.listEditDialogRef.open();
    }
  }

  searchInput(val) {
    this.searchVal = val;
    this.paginationRef.reset();
    this.paginationRef.getList();
  }

  //@methods
  getAppList(pageData: any) {
    this.loading = true;
    getAppList({
      projectId: this.projectID,
      ...pageData,
      homepageName: this.searchVal
    })
        .then((res) => {
          const {content} = res.data;
          //更新分页
          this.paginationRef.updatePagination(res.data);
          this.cardSetting.list = (content || []).map((item: any) => {
            return {
              title: item.homepageName,
              bodyIcon: 'if-icon-time',
              bodyText: moment(item.updateTime).format('YYYY-MM-DD'),
              bodyTags: (item.deviceTags || []).map((tag: any) => {
                return {
                  label: tag.name,
                };
              }),
              batchSelected: false,
              sourceData: item,
            };
          });
        })
        .finally(() => {
          this.loading = false;
          this.pageVisible = this.searchVal ? true : !!this.cardSetting.list.length;
        });
  }

  goAppEdit(item) {
    this.$router.push({
      name: '项目管理_项目详情_前端管理_应用界面配置_编辑',
      params: {
        configuration: item.sourceData.homepageId
      }
    });
  }

  appDelete(app: any) {
    this.$confirm(
        '删除后，则相关机器人不再具备该应用',
        `确认删除 ${app.title}？`,
        {
          customClass: 'rop-confirm-box',
          cancelButtonClass: 'rop-btn size-dialog light',
          confirmButtonClass: 'rop-btn size-dialog dark',
        }
    )
        .then(() => {
          this.loading = true;

          appDelete({
            homepageId: app.sourceData.homepageId,
          })
              .then((res) => {
                this.$message.success('删除成功');
                this.paginationRef.getList();
              })
              .finally(() => {
                this.loading = false;
              });
        })
        .catch(() => {
          return;
        });
  }

  listDialogSuccess(data: any) {
    //新建成功做跳转
    if (data && data.homepageId) {
      return this.goAppEdit({
        sourceData: data
      });
    }
    this.paginationRef.getList();
  }
}
